export enum UserPermission {
  GET_SIGNUP = 'getSignup',
  MANAGE_SIGNUP = 'manageSignup',

  GET_ONBOARDING = 'getOnboarding',
  MANAGE_ONBOARDING = 'manageOnboarding',

  MANAGE_LOS = 'manageLOS',
  GET_LOS = 'getLOS',

  MANAGE_SPACE_TYPE = 'manageSpaceType',
  GET_SPACE_TYPE = 'getSpaceType',

  MANAGE_DRIVER = 'manageDriver',
  GET_DRIVER = 'getDriver',

  MANAGE_MEMBER = 'manageMember',
  GET_MEMBER = 'getMember',

  MANAGE_VEHICLE = 'manageVehicle',
  GET_VEHICLE = 'getVehicle',

  MANAGE_FARES = 'manageFares',
  GET_FARES = 'getFares',

  GET_THRESHOLD = 'getThreshold',
  MANAGE_THRESHOLD = 'manageThreshold',
  GET_THRESHOLD_DASHBOARD = 'getThresholdDashboard',

  GET_USERS = 'getUsers',
  MANAGE_USERS = 'manageUsers',

  MANAGE_COMPANY = 'manageCompany',
  GET_COMPANY = 'getCompany',

  MANAGE_ROLE = 'manageRole',
  GET_ROLE = 'getRole',

  MANAGE_NOTIFICATION = 'manageNotification',
  GET_NOTIFICATION = 'getNotification',

  MANAGE_APPOINTMENT_TYPE = 'manageAppointmentType',
  GET_APPOINTMENT_TYPE = 'getAppointmentType',

  MANAGE_TRIP = 'manageTrip',
  GET_TRIP = 'getTrip',

  MANAGE_MEMBER_TRIP = 'manageMemberTrip',
  GET_MEMBER_TRIP = 'getMemberTrip',

  MANAGE_FUNDING_SOURCE_TRIP = 'manageFundingsourceTrip',
  GET_FUNDING_SOURCE_TRIP = 'getFundingsourceTrip',

  MANAGE_ADDON = 'manageAddon',
  GET_ADDON = 'getAddon',

  MANAGE_STANDING_ORDER = 'manageStandingorder',
  GET_STANDING_ORDER = 'getStandingorder',

  MANAGE_FUNDING_SOURCE = 'manageFundingsource',
  GET_FUNDING_SOURCE = 'getFundingsource',

  MANAGE_SERVICE_AREAS = 'manageServiceareas',
  GET_SERVICE_AREAS = 'getServiceareas',

  MANAGE_CHANGE_REASON = 'manageChangeReason',
  GET_CHANGE_REASON = 'getChangeReason',

  MANAGE_PLACE_TYPES = 'managePlaceTypes',
  GET_PLACE_TYPES = 'getPlaceTypes',

  MANAGE_BILLINGS = 'manageBillings',
  GET_BILLINGS = 'getBillings',

  MANAGE_GPS = 'manageGps',
  GET_GPS = 'getGps',

  MANAGE_EVENT = 'manageEvent',
  GET_EVENT = 'getEvent',

  MANAGE_COMPANY_CONFIGURATION = 'manageCompanyConfiguration',
  GET_COMPANY_CONFIGURATION = 'getCompanyConfiguration',

  GET_DRIVRER_ACTIVITY = 'getDriverActivity',
  MANAGE_DRIVER_ACTIVITY = 'manageDriverActivity',

  GET_CONFIGURATION = 'getConfiguration',
  MANAGE_CONFIGURATION = 'manageConfiguration',

  MANAGE_QUICKBOOKS = 'manageQuickbooks',
  MANAGE_FUNDINGSOURCE_BILLINGS = 'manageFundingSourceBillings',
  GET_FUNDINGSOURCE_BILLINGS = 'getFundingSourceBillings',

  MANAGE_PAYMENT = 'managePayment',


  GET_ACADEMY = 'getAcademy',
  MANAGE_ACADEMY = 'manageAcademy',
  GET_DOCUMENT_STATS = 'getDocumentStats',
}

export enum BillingStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  PAID = 'paid',
  RESUBMIT = 'resubmit'
}

export enum LineItemType {
  SALES_ITEM = 'SalesItemLineDetail',
  DESCRIPTION_ONLY = 'DescriptionOnly',
  DISCOUNT = 'DiscountLineDetail'
}

export enum OnboardingMenu {
  DASHBOARD = 'dashboard',
  CONFIGURATION = 'configuration',
  COMPANY = 'company',
  DRIVERS = 'drivers',
  VEHICLES = 'vehicles',
  RATES = 'rates',
  THRESHOLD = 'threshold',
  ATTACHMENTS = 'attachments'
}
